<template lang="pug">
  div
    span( v-if="! proxyDetails" ) -
    span( v-else-if="proxyDetails.errorMessage" ) {{ proxyDetails.errorMessage }}
    ul( v-else )
      li Residential Proxy: {{ proxyDetails.isResidential ? 'Y' : 'N' }}
      li IP: {{ proxyDetails.ip }}
      li Country: {{ (proxyDetails && proxyDetails.country) || 'N/A' }}
      li ASN:
        ul
          li AS Num: {{ proxyDetails.asn.asnum }}
          li Organisation: {{ proxyDetails.asn.org_name }}
      li Geo:
        ul
          li City: {{ proxyDetails.geo.city }}
          li Region: {{ proxyDetails.geo.region_name }}
          li Postal Code: {{ proxyDetails.geo.postal_code }}
          li Lat: {{ proxyDetails.geo.latitude }}
          li Lng: {{ proxyDetails.geo.longitude }}
          li Timezone: {{ proxyDetails.geo.tz }}
</template>

<script>
export default {
  props: {
    proxyDetails: {
      type: Object,
      required: true
    }
  }
}
</script>
